import {
  FETCH_BUSINESSES_REQUEST,
  FETCH_BUSINESSES_SUCCESS,
  FETCH_BUSINESSES_FAILURE,
  UPDATE_BUSINESS_STATUS_REQUEST,
  UPDATE_BUSINESS_STATUS_SUCCESS,
  UPDATE_BUSINESS_STATUS_FAILURE,
} from '../actions/types';

const initialState = {
  businesses: [],
  loading: false,
  error: null,
  message: '',
};

// Reducer for handling business actions
export default function businessReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_BUSINESSES_REQUEST:
    case UPDATE_BUSINESS_STATUS_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_BUSINESSES_SUCCESS:
      return {
        ...state,
        loading: false,
        businesses: action.payload,
        message: 'Businesses loaded successfully',
      };

    case FETCH_BUSINESSES_FAILURE:
    case UPDATE_BUSINESS_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_BUSINESS_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        businesses: Array.isArray(state.businesses)
          ? state.businesses.map((business) =>
            business.id === action.payload.id
              ? { ...business, ...action.payload }
              : business
          )
          : [],
        message: 'Business status updated successfully',
      };


    default:
      return state;
  }
}
